import { useRouteError } from "react-router-dom";
import { useSiteLocale } from "./useSiteLocale";

export function RouteError() {
  const error = useRouteError();
  const { locale } = useSiteLocale();
  const assetFailure = error instanceof Error && /Unable to preload CSS|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(error.message);
  const zh = locale === "zh";

  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: "24px" }}>
      <section role="alert" style={{ maxWidth: "520px", textAlign: "center" }}>
        <h1>{zh ? "页面暂时无法打开" : "This page couldn't load"}</h1>
        <p>{assetFailure
          ? (zh ? "页面资源未能加载，可能是网站刚刚更新或网络暂时中断。请刷新后重试。" : "Some page files couldn't load. The site may have updated, or the connection was interrupted. Please refresh to try again.")
          : (zh ? "页面遇到了问题，请刷新后重试。" : "Something went wrong. Please refresh to try again.")}</p>
        <button type="button" onClick={() => window.location.reload()}>{zh ? "刷新页面" : "Refresh page"}</button>
        <p><a href="/">{zh ? "返回首页" : "Back to home"}</a></p>
      </section>
    </main>
  );
}
